import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
import Icon from '../assets'

export interface AddTopicAnchorProps {
  title: string
  categoryId: string | null
}

const AddTopicAnchor: FunctionalComponent<AddTopicAnchorProps> = ({ title, categoryId }) => {
  return (
    <a
      href={categoryId ? `/topic/new?fid=${categoryId}` : '/topic/new'}
      data-track={JSON.stringify({
        trigger: 'navigation',
        type: 'Topic Initiated'
      })}
      data-ga-track={JSON.stringify({
        eventCategory: 'Homepage',
        eventAction: 'Create topic clicked',
        eventLabel: { Position: 'Navigation' }
      })}
      className={classnames('menu-create-topic', 'qa-menu-create-topic', 'btn', 'btn--cta')}
      role='button'
      title={title}
    >
      <span aria-hidden='true' className='header-navigation-button-icon'>
        <Icon icon='add' width={16} height={16} color='currentColor' />
      </span>
      <span>{title}</span>
    </a>
  )
}

export default AddTopicAnchor
